import { render, staticRenderFns } from "./Hxwhc.vue?vue&type=template&id=2c9e72c6&scoped=true&"
import script from "./Hxwhc.vue?vue&type=script&lang=js&"
export * from "./Hxwhc.vue?vue&type=script&lang=js&"
import style0 from "./Hxwhc.vue?vue&type=style&index=0&id=2c9e72c6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9e72c6",
  null
  
)

export default component.exports